import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lessOrEqualThanArray',
})
export class LessOrEqualThanArrayPipe implements PipeTransform {
  transform(value: any[], valueToCompare: any[]): boolean {
    if (!value || !valueToCompare) return false;
    return value.length <= valueToCompare.length;
  }
}
